"use client";

import { useContextStrict } from "@repo/design-system/hooks/use-context-strict";
import { LanguageContext } from "@repo/design-system/providers/language-provider";
import type { TranslationsMap } from "./init";

export function useLanguage() {
  return useContextStrict(LanguageContext) as TranslationsMap;
}
